import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { BillingTier } from '../../../types/BillingTier';

export const fetchBillingTier = async (uuid: string | null) => {
  if (!uuid) return null;

  const response = await CustomAxios.get<BillingTier>(`user_roles/tier/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetBillingTierByIdProps {
  enabled?: boolean;
  uuid: string | null;
}
export function useGetBillingTierById({ enabled = true, uuid }: UseGetBillingTierByIdProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.allBillingTiers, uuid],
    queryFn: () => fetchBillingTier(uuid),
  });

  return query;
}
